export default __webpack_public_path__ + "static/media/loanRepayment.c971e08d.svg";